<template>
  <div>
    <div v-if="downloading" class="flex justify-center items-center loading-dialog3">
      <p class="text-gray-600 font-bold animate-pulse" style="font-size: 30px">Downloading...</p>
    </div>
    <PageHeader :title="`apollo-RP - ${typeName}`" class="list">
      <template #title-header-content>

        <div class="bg-white flex text-white font-bold text-sm p-2 rounded mx-auto w-fit gap-2">
          <div class="w-28 rounded py-1 text-center cursor-pointer" :class="tab==1?'bg-blue-700':'bg-gray-400'" @click="clickTab(1)">貼紙</div>
          <div class="w-28 rounded py-1 text-center cursor-pointer" :class="tab==2?'bg-blue-700':'bg-gray-400'" @click="clickTab(2)">完了報告</div>
        </div>
        <div class="flex-1 pl-2 flex ml-6 justify-end items-center">
          <PrimaryButton
            text="検索"
            class="ml-auto flex button-contents"
            @click="getData()"
            :buttonContents="'要'"
          >
          </PrimaryButton>

          <h1 class="text-lg font-bold text-white flex items-center ml-2">
            <Icon iconName="" class="w-7 h-7 mr-2" /> <span class="mt-0 ">{{ list.length }} 件</span>
          </h1>

          <div class="ml-2 flex">
            <PrimaryButton text="クリア" class="normalButtonColor" @click="clear" :buttonContents="'要'" />
          </div>

          <!-- 一括ダウンロード（完了報告のみ） -->
          <div v-if="tab==2" class="ml-2 flex">
            <PrimaryButton
              v-tooltip="'チェックした完了報告をまとめてダウンロード'"
              :text="`一括ダウンロード（${selectedRows.length}件）`"
              :disabled="!selectedRows.length"
              @click="completionReportDownolad"
              :buttonContents="'要'"
            >
              <Icon slot="before" iconName="Download" iconType="outline" :strokeWidth="2" class="h-5 w-5 mr-1" />
            </PrimaryButton>
          </div>

          <Icon
            iconName="Refresh" 
            :clickable="false" 
            :class="{'animate-spin': loading}" 
            class="text-white hover:text-gray-300 active:text-gray-400 ml-4 cursor-pointer"
            @click.native="getData"
          />
        </div>
      </template>
      <template #page-header-content>
        <div class="pl-4 flex justify-between">
          
          <!-- 予定日 -->
          <div class="ml-auto mt-4 mr-3 flex">
            <div class="text-xs text-gray-600 font-bold w-28" id="filter-date"  v-tooltip="'作業が複数日の場合、初日の作業日が検索対象'">
              <WmsDateInput
                name="startDay"
                v-model="filter.start"
                placeholder="予定日 検索"
              />
            </div>
            <div class="pt-3 mx-1 text-white font-bold">
              ～
            </div>
            <div class="text-xs text-gray-600 font-bold w-28" id="filter-date" v-tooltip="'作業が複数日の場合、初日の作業日が検索対象'">
              <WmsDateInput
                id="filter-date"
                name="endDay"
                :min="filter.start"
                v-model="filter.end"
                placeholder="予定日 検索"
              />
            </div>
          </div>
          <!-- 得意先 -->
          <div class="mr-2 mt-5">
            <input
              v-tooltip="'記号・スペースは無視します'"
              type="search"
              name="filterClient" 
              placeholder="得意先 検索"
              class="w-full py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900" 
              v-model="filter.client"
            />
          </div>
          <!-- 支店名 -->
          <div class="mr-2 mt-5">
            <input
              v-tooltip="'記号・スペースは無視します'"
              type="search"
              name="filterBranch" 
              placeholder="支店名 検索"
              class="w-full py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900" 
              v-model="filter.branch"
            />
          </div>
          <!-- 物件名 -->
          <div class="mt-5 mr-2">
            <input
              v-tooltip="'記号・スペースは無視します'"
              type="search"
              name="filterSite" 
              placeholder="物件名 検索"
              class="w-full py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900" 
              v-model="filter.site"
            />
          </div>
          <!-- 担当者 -->
          <div class="mt-5">
            <input
              v-tooltip="'スペースは無視します'"
              type="search"
              name="filterStaff" 
              placeholder="担当者 検索"
              class="w-full py-2 pr-3 border border-gray-300 rounded-md leading-5 focus:bg-white focus:ring-white focus:placeholder-gray-500 focus:text-gray-900" 
              v-model="filter.staff"
            />
          </div>
        </div>     
      </template>
    </PageHeader>

    <main class="absolute top-32 w-screen bottom-4 mt-5 list">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md border border-gray-200 overflow-auto h-full">
          <!-- 一覧 -->
          <div v-if="loading" class="w-full h-full flex justify-center items-center">
            <p class="text-gray-400 font-bold animate-pulse">Searching...</p>
          </div>

          <div v-if="!loading">
            <div class="rounded main-height">
              <table class="main table-auto overflow-auto">
                <thead class="main sticky top-0">
                  <tr v-if="list && list.length" class="border border-gray-200 bg-colu text-xs text-gray-500 tracking-wider">
                    <th scope="col" class="px-6 py-3 font-medium text-left">
                      予定日
                    </th>
                    <th scope="col" class="px-6 py-3 font-medium text-left">
                      得意先
                    </th>
                    <th scope="col" class="px-6 py-3 font-medium text-left">
                      支店名
                    </th>
                    <th scope="col" class="px-6 py-3 font-medium text-left">
                      物件名
                    </th>
                    <th scope="col" class="px-6 py-3 font-medium text-left">
                      担当者
                    </th>
                    <th scope="col" class="px-6 py-3 font-medium">
                      ダウンロード
                    </th>
                    <th v-if="tab==1" scope="col" class="px-6 py-3 font-medium">
                      棟まとめて
                    </th>
                    <!-- 一括ダウンロード 全選択 -->
                    <th v-else-if="tab==2" scope="col" class="px-6 py-3 font-medium">
                      <input
                        v-tooltip="'全選択／全解除'"
                        type="checkbox"
                        class="h-4 w-4 border-gray-400 rounded cursor-pointer"
                        v-model="allChecked"
                      />
                    </th>
                    <th v-if="tab==2" scope="col" class="px-6 py-3 font-medium"></th>
                  </tr>
                </thead>

                <tr v-for="(row, i) in list" :key="'l'+i" class="border border-gray-200 bg-white tracking-wider hover-color">

                  <!-- 予定日 -->
                  <td v-if="tab==1" class="px-6 py-3 whitespace-prerap text-sm text-gray-700 min-100">
                    {{ row.main }}
                    <div v-if="row.sub">
                      <div v-for="(s, sidx) in row.sub" :key="sidx" class="text-xs p-1 bg-blue-50 text-blue-700 rounded w-fit">
                        {{s}}
                      </div>
                    </div>
                  </td>
                  <td v-else-if="tab==2" class="px-6 py-3 whitespace-prerap text-sm text-gray-700 min-100">
                    {{ row.day }}
                  </td>
                  <td v-else-if="tab==2" class="px-6 py-3 whitespace-prerap text-sm text-gray-700 min-100">
                    {{ row.day }}
                  </td>
                  <!-- 得意先 -->
                  <td class="px-6 py-3 whitespace-prerap text-sm text-gray-700 min-300" v-tooltip="`得意先コード：${row.clientCode}`">
                    {{ row.clientName1 }}
                  </td>
                  <!-- 支店名 -->
                  <td class="px-6 py-3 whitespace-prerap text-sm text-gray-700 min-300" v-tooltip="`得意先コード：${row.clientCode}`">
                    {{ row.clientName2 }}
                  </td>
                  <!-- 物件名 -->
                  <td class="px-6 py-3 whitespace-prerap text-sm text-gray-700 min-300" v-tooltip="`物件コード：${row.siteCode}`">
                    {{ row.siteName }}
                    <span v-if="row.ridgeCode" class="text-red-700 font-bold">（{{ row.ridgeName }}）</span>
                  </td>
                  <!-- 担当者 -->
                  <td class="px-6 py-3 whitespace-nowrap text-sm text-gray-700 min-300">
                    {{ row.staff }}
                  </td>
                  <!-- ダウンロード -->
                  <td v-if="tab==1" class="w-28 text-center">
                    <PrimaryButton v-tooltip="'ダウンロード'" @click="openPosterModal(row, false)" :buttonContents="'要'">
                      <Icon slot="before" iconName="Download" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                    </PrimaryButton>
                  </td>
                  <!-- ダウンロード -->
                  <td v-if="tab==1" class="w-28 text-center">
                    <PrimaryButton v-if="row.rowspan>1" v-tooltip="'物件単位の張り紙ダウンロード'" @click="openPosterModal(row, true)" :buttonContents="'要'">
                      <Icon slot="before" iconName="Download" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                    </PrimaryButton>
                    <div v-else-if="row.siteCount>1" class="text-xs text-gray-500">
                      上の行と同物件
                    </div>
                  </td>

                  <!-- ダウンロード -->
                  <td v-if="tab==2" class="w-28 text-center">
                    <PrimaryButton v-tooltip="'ダウンロード'" @click="completionReportDownolad(row)" :buttonContents="'要'">
                      <Icon slot="before" iconName="Download" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
                    </PrimaryButton>
                  </td>
                  <!-- 一括ダウンロード 選択 -->
                  <td v-if="tab==2" class="w-28 text-center">
                    <input
                      type="checkbox"
                      class="h-4 w-4 border-gray-400 rounded cursor-pointer"
                      v-model="row.checked"
                    />
                  </td>
                  <!-- ダウンロード済み -->
                  <td v-if="tab==2" class="w-16 text-center">
                    <div v-if="row.outputFlg2" class="text-blue-700 p-1 mx-1 text-xs bg-blue-50">
                      出力済
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- ダウンロード画面 -->
    <PosterModal 
      v-model="posterModal"
      :target="target"
      :target2="target2"
      :bySite="bySite"
      :typeName="typeName"
      :open="posterModal"
      @modalClose="modalClose"
    />
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import PosterModal from '../components/PosterModal.vue'
import * as moment from 'moment'
import * as utils from '@libs/utils'
import * as backend from '@libs/backend'
import { FIXED_NEW_TEMP_NOMURA } from '@libs/constants.js'

import PageModel from '../../main/pages/PageModel.vue'

const settionStrageName = 'FixedPosterStorageItemName'

export default {
  extends: PageModel,
  components: {
    Icon,
    WmsDateInput,
    PageHeader,
    PosterModal,
    PrimaryButton
  },

  data() {
    return {
      loading: false,
      downloading: false,

      type: 3,
      typeName: '貼紙・完了報告',
      tab: 1,
      
       //検索
      filter: {
        client : '',
        branch : '',
        site : '',
        staff: '',
        start: moment().format('YYYY-MM-DD'),
        end: ''
      },
      // 表示するデータ
      list: [],
      // モーダルopen
      posterModal: false,
      // ダウンロードするデータ（棟ごと・1行ごと）
      target: {},
      // ダウンロードするデータ（棟をまとめて）
      target2: [],
      // ダウンロード方法 false：1行ごと true：棟をまとめる
      bySite: false
    }
  },

  computed: {
    // 一括ダウンロード対象（チェックされた行）
    selectedRows() {
      return this.list.filter((l) => l.checked)
    },

    // ヘッダーの全選択チェックボックス
    allChecked: {
      get() {
        return !!this.list.length && this.list.every((l) => l.checked)
      },
      set(val) {
        this.list.forEach((l) => {
          l.checked = val
        })
      }
    }
  },

  async created() {
    // 条件取得
    this.getCondition()

    await this.getData()
  },

  methods: {
    /**
     *  条件取得
     */
    getCondition(){
      const searchJson = sessionStorage.getItem(settionStrageName)
      const getItem = JSON.parse(searchJson)

      if (getItem) {
        this.filter = getItem
        if (getItem.tab) {
          this.tab = getItem.tab
        }
      }

      if (!this.filter.start) {
        this.filter.start = moment().format('YYYY-MM-DD')
      }
    },

    /**
     * データ取得
     */
    async getData() {

      this.loading = true
      this.list = []

      // 貼紙
      if (this.tab == 1) {
        const checkR = await backend.postData('patrolSchedule/getIncompleteByDate', { ...this.filter, type: this.type })
        if (checkR.data && checkR.data.data.length) {
          this.list = checkR.data.data
          let siteCodes = []
          for (let i = 0; i < this.list.length; i++) {
            const l = this.list[i]
            if (l.siteCount == 1) {
              l.rowspan = 1
            } else {
              if (siteCodes.includes(l.siteCode)) {
                l.rowspan = 1
              } else {
                l.rowspan = l.siteCount
                siteCodes.push(l.siteCode)
              }
            }
          }
        }

      // 完了報告
      } else if (this.tab == 2) {
        const res = await backend.postData('patrolSchedule/getCompletionReportList', { ...this.filter, type: this.type, target: FIXED_NEW_TEMP_NOMURA })
        if (res.data && res.data.data.length) {
          this.list = res.data.data
        }
        
        // 一括ダウンロードの選択状態
        // APIの戻り値にcheckedが無いため、$setで付与しないとリアクティブにならない
        this.list.forEach((l) => {
          this.$set(l, 'checked', false)
        })
      }

      this.setSessionStorage(this.filter, settionStrageName)
      this.loading = false
    },

    /**
     * タブ変更
     * @param val 変更値
     */
    clickTab(val) {
      this.tab = val
      this.getData()
    },

    /**
     * 検索条件をセッションストレージへ保存
     * @param {Object} searchCondition 
     * @param {String} storageName 
     */
    setSessionStorage(searchCondition, storageName) {
      const searchStr = JSON.stringify({ ...searchCondition, tab: this.tab })
      sessionStorage.setItem(storageName, searchStr)
    },

    // 検索条件をクリア
    clear() {
      sessionStorage.removeItem(settionStrageName)
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    },

    /**
     * 張り紙モーダルopen
     * @param row 対象データ
     * @param bySite 棟をまとめるか：falseまとめない、trueまとめる
     */
    openPosterModal(row, bySite) {
      this.target = {}
      this.target2 = []
      if (!bySite) {
        this.target = utils.clone(row)
      } else {
        this.target2 = this.list.filter((l) => {
          return l.siteCode == row.siteCode
        })
      }
      this.bySite = bySite
      this.posterModal = true
    },

    /**
     * 張り紙モーダルclose
     */
    modalClose() {
      this.posterModal = false
      this.target = {}
      this.target2 = []
    },

    /**
     * 完了報告書ダウンロード ボタン
     */
    async completionReportDownolad(row) {
      let rows = []
      if (row) {
        rows = [row]
      } else {
        rows = this.selectedRows
      }

      this.downloading = true
      const list = rows.map((r) => ({ siteCode: r.siteCode, siteName: r.siteName, day: r.day, id: r.id }))

      try {
        const res = await backend.postBlob2('patrolDownload/downloadFixedCompleteReport', { list })
        const blob = new Blob([res.data], { "Content-Type" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
        const a = document.createElement("a")
        a.href = (window.URL || window.webkitURL).createObjectURL(blob)
        a.download = `完了報告.xlsx`
        a.click()
        a.remove()
        await this.getData()
      } catch (e) {
        console.log(e)
      }

      this.downloading = false
    },
  },
}
</script>
<style scoped>
.main {
  width: 100%;
}

.bg-colu {
    background: #ebf0fb;
}

.col-no {
    width: 70px;  
}

.min-100 {
    min-width: 100px;
}

.hover-color:hover {
  background: rgba(163, 231, 228, 0.67) !important;
}

#filter-date >>> input[type=text] {
  height: 37.8px !important;
}

@media screen and (max-width: 1200px) {
  .list {
    min-width: 1200px !important;
    bottom: auto !important;
  }
}
</style>